// extracted by mini-css-extract-plugin
var _1 = "tjs-metadata-table__root";
var _2 = "tjs-metadata-table__value";
export { _1 as "root", _2 as "value" }
export default { "root": _1, "value": _2 }
